import React from 'react';

export default function ProductUom({ value = '' }: any) {
  const formated = value;
  return <>{formated}</>;
}
